<script setup>
import LeftsideBarVue from "@/components/LeftsideBar.vue";
import MainComponent from "@/components/MainComponent.vue";
import RightsideBar from "@/components/RightsideBar.vue";
import ArtistSection from "@/components/ArtistSection.vue";
import WarningBox from "@/components/WarningBox.vue";

// Import vector images
import art from "@/assets/images/art.png";
import art2 from "@/assets/images/art44-.png";

import { onMounted, ref } from "vue";
import axios from "axios";

const totalViews = ref(0);

const incrementView = async () => {
  try {
    const response = await axios.post("/api/views/increment");
    totalViews.value = response.data.total_views;
  } catch (error) {
    console.error("Failed to increment views:", error);
  }
};

onMounted(() => {
  incrementView();
});

</script>

<template>
  <!-- Warning Box -->
  <WarningBox />

  <!-- Move totalViews here to ensure uniform column top alignment -->
  <div v-if="totalViews > 0" class="mt-4 mb-2 flex justify-center relative z-20">
    <div class="bg-white/80 backdrop-blur-sm px-6 py-2 rounded-full shadow-sm border border-gray-100 flex items-center space-x-2">
      <span class="text-gray-500 text-sm font-medium">Total Views</span>
      <span class="text-gray-300">|</span>
      <span class="text-[#BF3131] font-bold text-lg">{{ totalViews }}</span>
    </div>
  </div>

  <!-- Outer wrapper -->
  <div class="relative max-w-[1440px] 2xl:max-w-[1700px] w-full mx-auto overflow-x-hidden flex flex-col md:grid md:grid-cols-12 gap-8 md:gap-6 py-6 px-4 xl:px-8">

  <!-- Background vectors -->
  <div class="absolute inset-0 pointer-events-none overflow-hidden z-0">
    <div
      class="absolute top-5 left-0 -translate-x-10 w-64 h-64 bg-no-repeat bg-contain opacity-30"
      :style="`background-image: url(${art})`"
    ></div>

    <div
      class="absolute bottom-5 right-40 w-72 h-72 bg-no-repeat bg-contain opacity-30"
      :style="`background-image: url(${art2})`"
    ></div>
  </div>

  <div class="order-2 md:order-1 md:col-span-3 relative z-10 h-full">
    <LeftsideBarVue />
  </div>

  <!-- Right Hand Virtual Wrapper (Main + RightSidebar + Artist) -->
  <div class="contents md:flex md:flex-col md:col-span-9 md:order-2 md:gap-6 relative z-10 h-full justify-between">
    
    <!-- Top Row Virtual Wrapper -->
    <div class="contents md:grid md:grid-cols-9 md:gap-6 md:items-stretch">
      <div class="order-1 md:order-1 md:col-span-6 relative z-10 h-full">
        <MainComponent />
      </div>

      <div class="order-3 md:order-2 md:col-span-3 relative z-10 h-full">
        <RightsideBar />
      </div>
    </div>

    <!-- Artist Section natively flows upward directly beneath Top Row -->
    <div class="order-4 md:order-3 w-full relative z-10 mt-auto">
      <ArtistSection />
    </div>

  </div>

</div>

</template>

<style scoped>
/* Optional: tweak container background if needed */
</style>
